
import React from 'react';

// Create a context for base URL that can be used throughout the app
export const BaseUrlContext = React.createContext<string>('');
